/**
 * @generated SignedSource<<880fa5ac480a71691e387e036c777b40>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type RecognitionScheduleQuery$variables = {
  aaid: string;
};
export type RecognitionScheduleQuery$data = {
  readonly unified: {
    readonly unifiedProfile: {
      readonly extensions?: ReadonlyArray<{
        readonly errorType: string | null;
        readonly statusCode: number | null;
      }> | null;
      readonly gamification?: {
        readonly recognitionSchedule?: {
          readonly availablePoints?: number;
          readonly currentTime?: number;
          readonly id?: string;
          readonly isStaff?: boolean;
          readonly nextRefresh?: number;
          readonly refreshPtsAmount?: number;
          readonly resetPointsStatus?: string;
          readonly status?: string;
          readonly timeUntilRefresh?: number;
          readonly userId?: string;
          readonly wasForced?: boolean;
          readonly wasUpdateNeeded?: boolean;
        } | null;
      } | null;
      readonly identifier?: string | null;
      readonly message?: string | null;
    } | null;
  } | null;
};
export type RecognitionScheduleQuery = {
  response: RecognitionScheduleQuery$data;
  variables: RecognitionScheduleQuery$variables;
};

const node: ConcreteRequest = (function () {
  var v0 = [
      {
        defaultValue: null,
        kind: 'LocalArgument',
        name: 'aaid',
      },
    ],
    v1 = [
      {
        kind: 'Variable',
        name: 'aaid',
        variableName: 'aaid',
      },
    ],
    v2 = {
      kind: 'InlineFragment',
      selections: [
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'identifier',
          storageKey: null,
        },
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'message',
          storageKey: null,
        },
        {
          alias: null,
          args: null,
          concreteType: 'UnifiedQueryErrorExtension',
          kind: 'LinkedField',
          name: 'extensions',
          plural: true,
          selections: [
            {
              alias: null,
              args: null,
              kind: 'ScalarField',
              name: 'statusCode',
              storageKey: null,
            },
            {
              alias: null,
              args: null,
              kind: 'ScalarField',
              name: 'errorType',
              storageKey: null,
            },
          ],
          storageKey: null,
        },
      ],
      type: 'UnifiedQueryError',
      abstractKey: null,
    },
    v3 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'id',
      storageKey: null,
    },
    v4 = {
      kind: 'InlineFragment',
      selections: [
        v3 /*: any*/,
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'currentTime',
          storageKey: null,
        },
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'availablePoints',
          storageKey: null,
        },
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'isStaff',
          storageKey: null,
        },
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'nextRefresh',
          storageKey: null,
        },
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'refreshPtsAmount',
          storageKey: null,
        },
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'resetPointsStatus',
          storageKey: null,
        },
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'status',
          storageKey: null,
        },
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'timeUntilRefresh',
          storageKey: null,
        },
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'userId',
          storageKey: null,
        },
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'wasForced',
          storageKey: null,
        },
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'wasUpdateNeeded',
          storageKey: null,
        },
      ],
      type: 'UnifiedGamificationRecognitionSchedule',
      abstractKey: null,
    },
    v5 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: '__typename',
      storageKey: null,
    };
  return {
    fragment: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Fragment',
      metadata: null,
      name: 'RecognitionScheduleQuery',
      selections: [
        {
          alias: null,
          args: null,
          concreteType: 'UnifiedQuery',
          kind: 'LinkedField',
          name: 'unified',
          plural: false,
          selections: [
            {
              alias: null,
              args: v1 /*: any*/,
              concreteType: null,
              kind: 'LinkedField',
              name: 'unifiedProfile',
              plural: false,
              selections: [
                v2 /*: any*/,
                {
                  kind: 'InlineFragment',
                  selections: [
                    {
                      alias: null,
                      args: null,
                      concreteType: null,
                      kind: 'LinkedField',
                      name: 'gamification',
                      plural: false,
                      selections: [
                        {
                          kind: 'InlineFragment',
                          selections: [
                            {
                              alias: null,
                              args: null,
                              concreteType: null,
                              kind: 'LinkedField',
                              name: 'recognitionSchedule',
                              plural: false,
                              selections: [v4 /*: any*/],
                              storageKey: null,
                            },
                          ],
                          type: 'UnifiedGamification',
                          abstractKey: null,
                        },
                      ],
                      storageKey: null,
                    },
                  ],
                  type: 'UnifiedProfile',
                  abstractKey: null,
                },
              ],
              storageKey: null,
            },
          ],
          storageKey: null,
        },
      ],
      type: 'Query',
      abstractKey: null,
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Operation',
      name: 'RecognitionScheduleQuery',
      selections: [
        {
          alias: null,
          args: null,
          concreteType: 'UnifiedQuery',
          kind: 'LinkedField',
          name: 'unified',
          plural: false,
          selections: [
            {
              alias: null,
              args: v1 /*: any*/,
              concreteType: null,
              kind: 'LinkedField',
              name: 'unifiedProfile',
              plural: false,
              selections: [
                v5 /*: any*/,
                v2 /*: any*/,
                {
                  kind: 'InlineFragment',
                  selections: [
                    {
                      alias: null,
                      args: null,
                      concreteType: null,
                      kind: 'LinkedField',
                      name: 'gamification',
                      plural: false,
                      selections: [
                        v5 /*: any*/,
                        {
                          kind: 'InlineFragment',
                          selections: [
                            {
                              alias: null,
                              args: null,
                              concreteType: null,
                              kind: 'LinkedField',
                              name: 'recognitionSchedule',
                              plural: false,
                              selections: [v5 /*: any*/, v4 /*: any*/],
                              storageKey: null,
                            },
                            v3 /*: any*/,
                          ],
                          type: 'UnifiedGamification',
                          abstractKey: null,
                        },
                      ],
                      storageKey: null,
                    },
                    v3 /*: any*/,
                  ],
                  type: 'UnifiedProfile',
                  abstractKey: null,
                },
              ],
              storageKey: null,
            },
          ],
          storageKey: null,
        },
      ],
    },
    params: {
      cacheID: '4ee1e2029e57f0d79a37597a0b859129',
      id: null,
      metadata: {},
      name: 'RecognitionScheduleQuery',
      operationKind: 'query',
      text: 'query RecognitionScheduleQuery(\n  $aaid: String!\n) {\n  unified {\n    unifiedProfile(aaid: $aaid) {\n      __typename\n      ... on UnifiedQueryError {\n        identifier\n        message\n        extensions {\n          statusCode\n          errorType\n        }\n      }\n      ... on UnifiedProfile {\n        gamification {\n          __typename\n          ... on UnifiedGamification {\n            recognitionSchedule {\n              __typename\n              ... on UnifiedGamificationRecognitionSchedule {\n                id\n                currentTime\n                availablePoints\n                isStaff\n                nextRefresh\n                refreshPtsAmount\n                resetPointsStatus\n                status\n                timeUntilRefresh\n                userId\n                wasForced\n                wasUpdateNeeded\n              }\n            }\n            id\n          }\n        }\n        id\n      }\n    }\n  }\n}\n',
    },
  };
})();

(node as any).hash = '601a9347fcfda55697b5cc4825e2992e';

export default node;
